import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  className = '',
  href = '#acceso',
  onClick
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    } else {
      // Fire Meta Pixel AddToCart for external checkout links
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart');
      }
    }
    onClick?.();
  };
  return <motion.a href={href} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={handleClick} className={`inline-block text-center bg-gradient-to-r from-gold to-gold-light text-navy font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-gold/40 transition-shadow duration-300 cursor-pointer ${className}`} data-id="element-163">
      {children}
    </motion.a>;
}